// extracted by mini-css-extract-plugin
export default {"loading_overlay":"LoadingOverlay_loading_overlay__KuwSO","container":"LoadingOverlay_container__EKohq","icon":"LoadingOverlay_icon__O8brc","message":"LoadingOverlay_message__g9Wjz"};